<nav class="navbar navbar-expand-md navbar-dark navbar-color text-center logo-parent py-0">
    <div class="navbar-brand logo-style"><img class="logo-height" src="../assets/AITEM_Black.png" [routerLink]="['/home']"></div>
    <button *ngIf="patientId != ''" class="navbar-toggler xs-col-1" type="button" aria-controls="navbarContent"
      [attr.aria-expanded]="!collapsed" aria-label="Toggle navigation" (click)="collapsed = !collapsed">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div *ngIf="patientId != ''" class="navbar-collapse" [class.collapse]="collapsed" id="navbarContent">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link sendFeedback" (click)="open()">
            Send Feedback
          </a>
        </li>
      </ul>
    </div>
    <div class="navbar-nav back-button text-light">
      <a class="nav-link" [routerLink]="['/home']"><i class="bi bi-arrow-left-square back-button-size"></i></a>
    </div>
  </nav>